module.exports = __webpack_public_path__ + "static/media/fg-water-palm.6af11eb1.svg";